var _defs, _rect, _rect2, _rect3, _g, _path, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMirrorsEtching(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 320",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "me-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FBF5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F5EAD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "me-mirror",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F3FAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BFE0DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "me-frame",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D06E76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#821B26"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 320,
    fill: "url(#me-bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 50,
    width: 220,
    height: 220,
    rx: 18,
    fill: "url(#me-frame)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 62,
    width: 196,
    height: 196,
    rx: 10,
    fill: "url(#me-mirror)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffffff",
    strokeWidth: 2.5,
    fill: "none",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200 100 C 180 120, 180 150, 200 170 C 220 150, 220 120, 200 100 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 160 C 140 175, 140 200, 160 215 C 180 200, 180 175, 160 160 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 160 C 220 175, 220 200, 240 215 C 260 200, 260 175, 240 160 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 170 L200 220"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 140,
    r: 6,
    fill: "#ffffff",
    opacity: 0.5,
    stroke: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 80 L150 200",
    stroke: "#ffffff",
    strokeWidth: 8,
    opacity: 0.35,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 300,
    textAnchor: "middle",
    fontFamily: "Georgia, serif",
    fontSize: 14,
    fill: "#4E3F37",
    letterSpacing: 1
  }, "Etched &amp; Mirror Work")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirrorsEtching);
export default __webpack_public_path__ + "static/media/mirrors-etching.b09989be759f9a15ca6d1196151656e7.svg";
export { ForwardRef as ReactComponent };